import './index.scss'
$("#nav3").addClass("active");
$(".product-nav dl dt").click(function() {
    $(this).toggleClass("active");
    $(this).parent().find(".dd").slideToggle();
})